import { get as lodashGet, isNil } from 'lodash';
import { RaRecord } from 'ra-core';

export const formatCents = (cents: number) => {
  if (isNil(cents)) {
    return null;
  }
  return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
};

export const getInheritedValue = (
  inheritedSettings: Record<string, any>,
  key: string,
  parentSettings?: Record<string, any>,
) => {
  const value = lodashGet(inheritedSettings, key);
  if (!isNil(value) && value !== '') {
    return value;
  }

  const parentValue = lodashGet(parentSettings, key);
  if (!isNil(parentValue) && parentValue !== '') {
    return parentValue;
  }

  return null;
};

export const getInherited = (
  inheritedSettings: Record<string, any>,
  key: string,
  parentSettings?: Record<string, any>,
) => {
  const value = getInheritedValue(inheritedSettings, key, parentSettings);
  if (isNil(value)) {
    return '';
  }
  return String(value) || '';
};

export const formatInheritedCents = (
  inheritedSettings: Record<string, any>,
  key: string,
  parentSettings?: Record<string, any>,
) => formatCents(getInheritedValue(inheritedSettings, key, parentSettings));

const RESOURCE_RATE_SOURCES: Record<string, string> = {
  AgencyLocationPositionRateSetting: 'agency_id',
  AgencyLocationRateSetting: 'agency_id',
  MarketLocationTypePositionRateSetting: 'market_location_type_id',
  MarketLocationTypeRateSetting: 'market_location_type_id',
  MarketPositionRateSetting: 'market_id',
  MarketRateSetting: 'market_id',
  StateLocationTypePositionRateSetting: 'state_location_type_id',
  StateLocationTypeRateSetting: 'state_location_type_id',
  StatePositionRateSetting: 'state_id',
  StateRateSetting: 'state_id',
};

export const getRateSource = (record: RaRecord, resource: string) => {
  if (resource === 'LocationPositionRateSetting' || resource === 'LocationRateSetting') {
    return record?.agency_id ? 'agency_id' : 'location_id';
  }
  if (RESOURCE_RATE_SOURCES[resource]) {
    return RESOURCE_RATE_SOURCES[resource];
  }

  // Record-shape fallback for callers without a known resource.
  if (record?.location_id) {
    return record?.agency_id ? 'agency_id' : 'location_id';
  }
  if (record?.market_id && record?.location_type_id) {
    return 'market_location_type_id';
  }
  if (record?.market_id) {
    return 'market_id';
  }
  if (record?.location_type_id) {
    return 'state_location_type_id';
  }
  if (record?.state_id) {
    return 'state_id';
  }

  throw new Error('No rate representation found');
};
